export default [
  {
    path: '/settings',
    name: 'settings',
    meta: {
      access: 'settings'
    },
    component: () => import('@/views/Settings/Settings'),
    children: [
      {
        path: 'account',
        name: 'account',
        meta: {
          access: 'settings'
        },
        component: () => import('@/views/Settings/Account/Info'),
      },
      {
        path: 'account/edit',
        name: 'editAccount',
        meta: {
          access: 'settings'
        },
        component: () => import('@/views/Settings/Account/Edit'),
      },
      {
        path: 'sessions',
        name: 'sessions',
        meta: {
          access: 'settings'
        },
        component: () => import('@/views/Settings/Sessions'),
      },
      {
        path: 'qr-auth',
        name: 'authQR',
        meta: {
          access: 'settings'
        },
        component: () => import('@/views/Settings/QRSession'),
      }
    ]
  }
]
